module.exports = __webpack_public_path__ + "static/media/IconTemplates_-21.f0a4019b.svg";